var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: "三方媒资信息",
            visible: _vm.value,
            width: "800px",
            "modal-append-to-body": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.value = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "0 0 20px 50px" } },
            [
              _c("el-col", { attrs: { span: 11 } }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [_vm._v("三方媒资 ID：")]
                ),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.row.partnerData
                        ? _vm.row.partnerData.partnerMediaId || "--"
                        : "--"
                    )
                ),
              ]),
              _c("el-col", { attrs: { span: 2 } }),
              _c("el-col", { attrs: { span: 11 } }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [_vm._v("三方分集状态：")]
                ),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.row.partnerData
                        ? { 0: "已下架", 1: "已上架" }[
                            _vm.row.partnerData.partnerMediaStatus
                          ] || "--"
                        : "--"
                    )
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { margin: "0 0 20px 50px" } },
            [
              _c("el-col", { attrs: { span: 11 } }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [_vm._v("版权标识 ：")]
                ),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.row.partnerData
                        ? _vm.row.partnerData.copyrightMediaCode || "--"
                        : "--"
                    )
                ),
              ]),
              _c("el-col", { attrs: { span: 2 } }),
              _c("el-col", { attrs: { span: 11 } }, [
                _c(
                  "span",
                  { staticStyle: { display: "inline-block", width: "100px" } },
                  [_vm._v("版权商 ID：")]
                ),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.row.partnerData
                        ? _vm.row.partnerData.copyrightMediaId || "--"
                        : "--"
                    )
                ),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }